import { gql } from '@apollo/client';

export default gql`
  query TaxTransactionSyncExport(
    $states: [String!]
    $transactionKind: String
    $destinationState: String
    $reportableFrom: DateTimeScalar
    $reportableTo: DateTimeScalar
  ) {
    taxTransactionSyncExport(
      states: $states
      transactionKind: $transactionKind
      destinationState: $destinationState
      reportableFrom: $reportableFrom
      reportableTo: $reportableTo
    ) {
      filename
      contentType
      base64Data
      rowCount
    }
  }
`;
